import { Box } from "@mui/material";

import SymbolAutocomplete from "./SymbolAutocomplete";

export const AssayBar = () => (
  <Box
    bgcolor="primary.dark"
    className="assay-bar"
    height={60}
    display="flex"
    justifyContent="center"
    alignItems="center"
  >
    <SymbolAutocomplete />
  </Box>
);
